export default __webpack_public_path__ + "static/media/STROKING AND EXPENSTION MACHINE.16d32275.png";